import { Box, Card, CardContent, Grid, Typography, Tabs, Tab } from '@mui/material';
import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // Import Lightbox styles
import styled from 'styled-components';
import { Col } from 'react-bootstrap';
import GandhiJi from '../../assets/images/logos/gandhijiLogo.png';
import Logo from '../../assets/images/logos/logo.png';
import { bool } from 'prop-types';
import { useTranslation } from 'react-i18next';

// Import CTU images
// import ctuImg1 from '../../assets/ctu/Picture26.jpg';
// import ctuImg2 from '../../assets/ctu/Picture27.png';
// import ctuImg3 from '../../assets/ctu/Picture28.png';
// import ctuImg4 from '../../assets/ctu/Picture29.png';
// import ctuImg5 from '../../assets/ctu/Picture30.png';
// import ctuImg6 from '../../assets/ctu/Picture31.png';
// import ctuImg7 from '../../assets/ctu/Picture1.jpg';
// import ctuImg8 from '../../assets/ctu/CTU_1.jpg';
// import ctuImg9 from '../../assets/ctu/CTU_2.jpg';
// import ctuImg10 from '../../assets/ctu/CTU_3.jpg';
// import ctuImg11 from '../../assets/ctu/CTU_4.jpg';
// import ctuImg12 from '../../assets/ctu/Picture12.png';
// import ctuImg13 from '../../assets/ctu/Picture13.jpeg';
// import ctuImg14 from '../../assets/ctu/Picture14.jpeg';
// import ctuImg15 from '../../assets/ctu/Picture15.jpeg';
// import ctuImg16 from '../../assets/ctu/Picture30.jpg';
// import ctuImg17 from '../../assets/ctu/Picture31.jpg';
// import ctuImg18 from '../../assets/ctu/Picture32.jpg';
// import ctuImg19 from '../../assets/ctu/Picture33.jpeg';
// import ctuImg20 from '../../assets/ctu/CTU_5.jpg';
// import ctuImg21 from '../../assets/ctu/CTU_6.jpg';
// import ctuImg22 from '../../assets/ctu/CTU_7.jpg';
// import ctuImg23 from '../../assets/ctu/CTU_8.jpg';
// import ctuImg24 from '../../assets/ctu/CTU_9.jpeg';
// import ctuImg25 from '../../assets/ctu/CTU_10.jpeg';
// import ctuImg26 from '../../assets/ctu/CTU_11.jpeg';
// import ctuImg27 from '../../assets/ctu/CTU_12.jpeg';
// import ctuImg28 from '../../assets/ctu/Andhra_CM_1.jpeg';
// import ctuImg29 from '../../assets/ctu/CTU_13.jpeg';
// import ctuImg30 from '../../assets/ctu/CTU_14.jpeg';
// import ctuImg31 from '../../assets/ctu/CTU_15.jpeg';
// import ctuImg32 from '../../assets/ctu/CTU_16.jpeg';
// import ctuImg33 from '../../assets/ctu/CTU_17.jpg';
// import ctuImg34 from '../../assets/ctu/CTU_18.jpg';
// import ctuImg35 from '../../assets/ctu/CTUs_1.jpg';
// import ctuImg36 from '../../assets/ctu/CTUs_2.jpg';
// import ctuImg37 from '../../assets/ctu/CTUs_3.jpg';
// import ctuImg38 from '../../assets/ctu/CTUs_4.jpg';
// import ctuImg39 from '../../assets/ctu/CTUs_5.jpg';
// import ctuImg40 from '../../assets/ctu/CTUs_6.jpg';
// import ctuImg41 from '../../assets/ctu/CTUs_7.jpeg';
// import ctuImg42 from '../../assets/ctu/CTUs_8.jpeg';
// import ctuImg43 from '../../assets/ctu/CTUs_9.jpg';
// import ctuImg44 from '../../assets/ctu/CTU_19.jpeg';
// import ctuImg45 from '../../assets/ctu/CTU_20.jpeg';
// import ctuImg46 from '../../assets/ctu/CTUs_10.jpg';
// import ctuImg47 from '../../assets/ctu/CTUs_11.jpg';
// import ctuImg48 from '../../assets/ctu/CTUs_12.jpg';
// import ctuImg49 from '../../assets/ctu/CTUs_13.jpg';
// import ctuImg50 from '../../assets/ctu/CTUs_14.jpg';
// import ctuImg51 from '../../assets/ctu/CTU_21.jpg';
// import ctuImg52 from '../../assets/ctu/CTU_22.jpg';
// import ctuImg53 from '../../assets/ctu/CTU_23.jpg';
// import ctuImg54 from '../../assets/ctu/CTU_24.jpg';
// import ctuImg55 from '../../assets/ctu/CTU_25.jpg';
// import ctuImg56 from '../../assets/ctu/CTU_26.jpg';
// import ctuImg57 from '../../assets/ctu/CTU_57.jpg';
// import ctuImg58 from '../../assets/ctu/CTU_58.jpg';
// import ctuImg59 from '../../assets/ctu/CTU_59.jpg';
// import ctuImg60 from '../../assets/ctu/CTU_60.jpg';
// import ctuImg61 from '../../assets/ctu/CTU_61.jpg';
// import ctuImg62 from '../../assets/ctu/CTU_62.jpg';
// import ctuImg63 from '../../assets/ctu/CTU_63.jpg';
// import ctuImg64 from '../../assets/ctu/CTU_64.jpg';
// import ctuImg65 from '../../assets/ctu/CTU_65.jpg';
// import ctuImg66 from '../../assets/ctu/CTU_66.jpg';
// import ctuImg67 from '../../assets/ctu/CTU_67.jpg';
// import ctuImg68 from '../../assets/ctu/CTU_68.jpg';
// import ctuImg69 from '../../assets/ctu/CTU_69.jpg';

// Import Advocacy images
// import advocacyImg1 from '../../assets/advocacy/Picture16.jpg';
// import advocacyImg2 from '../../assets/advocacy/Picture17.png';
// import advocacyImg3 from '../../assets/advocacy/Picture18.jpg';
// import advocacyImg4 from '../../assets/advocacy/Advocacy_1.jpg';
// import advocacyImg5 from '../../assets/advocacy/Picture20.png';
// import advocacyImg6 from '../../assets/advocacy/Picture21.png';
// import advocacyImg7 from '../../assets/advocacy/Advocacy_2.jpg';
// import advocacyImg8 from '../../assets/advocacy/Advocacy_3.jpg';
// import advocacyImg9 from '../../assets/advocacy/Advocacy_4.jpg';
// import advocacyImg10 from '../../assets/advocacy/Advocacy_5.jpg';
// import advocacyImg11 from '../../assets/advocacy/Picture1.jpeg';
// import advocacyImg12 from '../../assets/advocacy/Picture2.jpeg';
// import advocacyImg13 from '../../assets/advocacy/Picture3.jpeg';
// import advocacyImg14 from '../../assets/advocacy/Picture4.jpeg';
// import advocacyImg15 from '../../assets/advocacy/Picture5.jpeg';
// import advocacyImg16 from '../../assets/advocacy/Picture6.jpeg';
// import advocacyImg17 from '../../assets/advocacy/Advocacy_6.jpg';
// import advocacyImg18 from '../../assets/advocacy/Advocacy_7.jpg';
// import advocacyImg19 from '../../assets/advocacy/Advocacy_8.jpg';
// import advocacyImg20 from '../../assets/advocacy/Advocacy_9.jpg';
// import advocacyImg21 from '../../assets/advocacy/Advocacy_10.jpg';
// import advocacyImg22 from '../../assets/advocacy/Advocacy_11.jpg';
// import advocacyImg23 from '../../assets/advocacy/Advocacy_12.jpg';
// import advocacyImg24 from '../../assets/advocacy/Advocacy_13.jpg';
// import advocacyImg25 from '../../assets/advocacy/Advocacy_14.jpg';
// import advocacyImg26 from '../../assets/advocacy/Advocacy_15.jpg';
// import advocacyImg27 from '../../assets/advocacy/Advocacy_16.jpg';
// import advocacyImg28 from '../../assets/advocacy/Advocacy_17.jpg';
// import advocacyImg29 from '../../assets/advocacy/Advocacy_18.jpg';
// import advocacyImg30 from '../../assets/advocacy/Advocacy_19.jpg';
// import advocacyImg31 from '../../assets/advocacy/Advocacy_20.jpg';
// import advocacyImg32 from '../../assets/advocacy/Advocacy_21.jpg';
// import advocacyImg33 from '../../assets/advocacy/Advocacy_22.jpg';
// import advocacyImg34 from '../../assets/advocacy/Advocacy_23.jpg';
// import advocacyImg35 from '../../assets/advocacy/Advocacy_24.jpg';
// import advocacyImg36 from '../../assets/advocacy/Advocacy_25.jpg';
// import advocacyImg37 from '../../assets/advocacy/Advocacy_26.jpg';
// import advocacyImg38 from '../../assets/advocacy/Advocacy_27.jpg';
// import advocacyImg39 from '../../assets/advocacy/Advocacy_28.jpg';
// import advocacyImg40 from '../../assets/advocacy/Advocacy_29.jpg';
// import advocacyImg41 from '../../assets/advocacy/advocacy_30.jpg';
// import advocacyImg42 from '../../assets/advocacy/advocacy_31.jpg';
// import advocacyImg43 from '../../assets/advocacy/Advocacy_32.jpg';
// import advocacyImg44 from '../../assets/advocacy/Advocacy_33.jpg';
// import advocacyImg45 from '../../assets/advocacy/Advocacy_34.jpg';
// import advocacyImg46 from '../../assets/advocacy/Advocacy_35.jpg';
// import advocacyImg47 from '../../assets/advocacy/Advocacy_36.jpg';
// import advocacyImg48 from '../../assets/advocacy/advocacy_37.jpg';
// import advocacyImg49 from '../../assets/advocacy/advocacy_38.jpg';
// import advocacyImg50 from '../../assets/advocacy/advocacy_39.jpg';
// import advocacyImg51 from '../../assets/advocacy/advocacy_40.jpg';
// import advocacyImg52 from '../../assets/advocacy/Advocacy_41.jpg';
// import advocacyImg53 from '../../assets/advocacy/Advocacy_42.jpg';
// import advocacyImg54 from '../../assets/advocacy/Advocacy_43.jpg';

// Import Clean Green Festives images
// import festiveImg1 from '../../assets/clean_green_festives/65eaa80882244327758715.jpg';
// import festiveImg2 from '../../assets/clean_green_festives/65eaa808bbab6210890424.jpg';
// import festiveImg3 from '../../assets/clean_green_festives/65eaa808c4466809336801.jpg';
// import festiveImg4 from '../../assets/clean_green_festives/65eaa80930906378650133.jpeg';
// import festiveImg5 from '../../assets/clean_green_festives/65eaa809d0be3039546340.jpeg';
// import festiveImg6 from '../../assets/clean_green_festives/65eaa80a1fce6157771631.jpg';
// import festiveImg7 from '../../assets/clean_green_festives/65eaa80a294bf075748009.jpg';
// import festiveImg8 from '../../assets/clean_green_festives/Clean_Green_festivities_1.jpg';
// import festiveImg9 from '../../assets/clean_green_festives/Clean_Green_Festivities.jpg';
// import festiveImg10 from '../../assets/clean_green_festives/Clean_Green_Festivities_2.jpg';
// import festiveImg11 from '../../assets/clean_green_festives/Clean_Green_Festivities_3.jpg';
// import festiveImg12 from '../../assets/clean_green_festives/Clean_Green_Festivities_4.jpg';
// import festiveImg13 from '../../assets/clean_green_festives/Clean_Green_Festivities_5.jpg';
// import festiveImg14 from '../../assets/clean_green_festives/Clean_Green_Festivities_6.jpeg';
// import festiveImg15 from '../../assets/clean_green_festives/Clean_Green_Festivities_7.jpg';
// import festiveImg16 from '../../assets/clean_green_festives/Clean_Green_Festivities_8.jpg';
// import festiveImg17 from '../../assets/clean_green_festives/Clean_Green_Festivities_9.jpg';
// import festiveImg18 from '../../assets/clean_green_festives/Clean_Green_Festivities_10.jpg';

// Import Clean Public Spaces images
// import publicImg1 from '../../assets/clean_public_places/Clean_Public_Spaces_1.jpg';
// import publicImg2 from '../../assets/clean_public_places/Clean_Public_Spaces_2.jpg';
// import publicImg3 from '../../assets/clean_public_places/Picture2.png';
// import publicImg4 from '../../assets/clean_public_places/Picture3.jpg';
// import publicImg5 from '../../assets/clean_public_places/Picture4.jpg';
// import publicImg6 from '../../assets/clean_public_places/Clean_Public_Spaces_3.jpg';
// import publicImg7 from '../../assets/clean_public_places/Clean_Public_Spaces_4.jpg';
// import publicImg8 from '../../assets/clean_public_places/Picture8.jpg';
// import publicImg9 from '../../assets/clean_public_places/Picture9.png';
// import publicImg10 from '../../assets/clean_public_places/Picture13.jpeg';
// import publicImg11 from '../../assets/clean_public_places/Picture14.jpeg';
// import publicImg12 from '../../assets/clean_public_places/Picture15.jpeg';
// import publicImg13 from '../../assets/clean_public_places/Picture16.jpeg';
// import publicImg14 from '../../assets/clean_public_places/Picture17.jpeg';
// import publicImg15 from '../../assets/clean_public_places/Picture18.jpeg';
// import publicImg16 from '../../assets/clean_public_places/Clean_Public_Spaces_5.jpeg';
// import publicImg17 from '../../assets/clean_public_places/Clean_Public_Spaces_6.jpg';
// import publicImg18 from '../../assets/clean_public_places/Clean_Public_Spaces_7.jpg';
// import publicImg19 from '../../assets/clean_public_places/Clean_Public_Spaces_8.jpg';
// import publicImg20 from '../../assets/clean_public_places/Clean_Public_Places_9.jpg';
// import publicImg21 from '../../assets/clean_public_places/Clean_Public_Places_10.jpg';
// import publicImg22 from '../../assets/clean_public_places/Clean_Public_Places_11.jpg';
// import publicImg23 from '../../assets/clean_public_places/Clean_Public_Places_12.jpg';
// import publicImg24 from '../../assets/clean_public_places/Clean_Public_Places_13.jpg';
// import publicImg25 from '../../assets/clean_public_places/Clean_Public_Places_14.jpg';
// import publicImg26 from '../../assets/clean_public_places/Clean_Public_Places_15.jpg';
// import publicImg27 from '../../assets/clean_public_places/Clean_Public_Places_16.jpg';
// import publicImg28 from '../../assets/clean_public_places/Clean_Public_Places_17.jpg';
// import publicImg29 from '../../assets/clean_public_places/Clean_Public_Places_18.jpg';
// import publicImg30 from '../../assets/clean_public_places/Clean_Public_Places_19.jpg';
// import publicImg31 from '../../assets/clean_public_places/Clean_Punlic_Places_20.jpg';
// import publicImg32 from '../../assets/clean_public_places/Clean_Punlic_Places_21.jpg';
// import publicImg33 from '../../assets/clean_public_places/Clean_Punlic_Places_22.jpg';
// import publicImg34 from '../../assets/clean_public_places/Clean_Punlic_Places_23.jpg';
// import publicImg35 from '../../assets/clean_public_places/Clean_Public_Spces_24.jpg';
// import publicImg36 from '../../assets/clean_public_places/Clean_Public_Spces_25.jpg';
// import publicImg37 from '../../assets/clean_public_places/Clean_Public_Spces_26.jpg';
// import publicImg38 from '../../assets/clean_public_places/Clean_Public_Spces_27.jpg';
// import publicImg39 from '../../assets/clean_public_places/Clean_Public_Spces_28.jpg';
// import publicImg40 from '../../assets/clean_public_places/Clean_Public_Spaces_29.jpg';
// import publicImg41 from '../../assets/clean_public_places/Clean_Public_Spaces_30.jpg';
// import publicImg42 from '../../assets/clean_public_places/Clean_Public_Spaces_31.jpg';
// import publicImg43 from '../../assets/clean_public_places/Clean_Public_Spaces_32.jpg';
// import publicImg44 from '../../assets/clean_public_places/Clean_Public_Spaces_33.jpg';
// import publicImg45 from '../../assets/clean_public_places/Clean_Public_Spaces_34.jpg';
// import publicImg46 from '../../assets/clean_public_places/Clean_Public_Spaces_35.jpg';
// import publicImg47 from '../../assets/clean_public_places/Clean_Public_Spaces_24.jpg';
// import publicImg48 from '../../assets/clean_public_places/Clean_Public_Spaces_25.jpg';
// import publicImg49 from '../../assets/clean_public_places/Clean_Public_Spaces_26.jpg';
// import publicImg50 from '../../assets/clean_public_places/Clean_Public_Spaces_27.jpg';
// import publicImg51 from '../../assets/clean_public_places/Clean_Public_Spaces_36.jpg';
// import publicImg52 from '../../assets/clean_public_places/Clean_Public_Spaces_37.jpg';
// import publicImg53 from '../../assets/clean_public_places/Clean_Public_Spaces_38.jpg';

// Import Shivirs images
// import shivirImg1 from '../../assets/shivirs/1.jpg';
// import shivirImg2 from '../../assets/shivirs/2.jpg';
// import shivirImg3 from '../../assets/shivirs/3.jpg';
// import shivirImg4 from '../../assets/shivirs/4.jpg';
// import shivirImg5 from '../../assets/shivirs/5.jpg';
// import shivirImg6 from '../../assets/shivirs/6.jpg';
// import shivirImg7 from '../../assets/shivirs/7.jpg';
// import shivirImg8 from '../../assets/shivirs/8.jpg';
// import shivirImg9 from '../../assets/shivirs/shivirImg9.jpeg';
// import shivirImg10 from '../../assets/shivirs/shivirImg10.jpeg';
// import shivirImg11 from '../../assets/shivirs/shivirImg11.jpeg';
// import shivirImg12 from '../../assets/shivirs/shivirImg12.jpeg';
// import shivirImg13 from '../../assets/shivirs/SafaiMitra_Suraksha_1.jpg';
// import shivirImg14 from '../../assets/shivirs/SafaiMitra_Suraksha_2.jpg';
// import shivirImg15 from '../../assets/shivirs/SafaiMitra_Suraksha_3.jpg';
// import shivirImg16 from '../../assets/shivirs/SafaiMitra_Suraksha_4.jpg';
// import shivirImg17 from '../../assets/shivirs/Safaimitra_Suraksha_5.jpg';
// import shivirImg18 from '../../assets/shivirs/Safaimitra_Suraksha_6.jpg';
// import shivirImg19 from '../../assets/shivirs/Safaimitra_Suraksha_7.jpg';
// import shivirImg20 from '../../assets/shivirs/SafaiMitra_Suraksha.jpg';
// import shivirImg21 from '../../assets/shivirs/SafaiMitra_Suraksha_8.jpg';
// import shivirImg22 from '../../assets/shivirs/SafaiMitra_Suraksha_9.jpg';
// import shivirImg23 from '../../assets/shivirs/SafaiMitra_Suraksha_10.jpg';
// import shivirImg24 from '../../assets/shivirs/SafaiMitra_Suraksha_11.jpg';
// import shivirImg25 from '../../assets/shivirs/SafaiMitra_Suraksha_12.jpg';
// import shivirImg26 from '../../assets/shivirs/safaimitra_suraksha_13.jpeg';
// import shivirImg27 from '../../assets/shivirs/safaimitra_suraksha_14.jpg';

// --- SHS-2026 gallery images (added 2026-09-21) ---------------------------
// Rotated out 2026-09-30 when the third batch below went in; each tab keeps
// the newest eight. Files remain in src/assets/Images-2026/.
// CTU -> ctu tab
// import ctu2026Bhubaneshwar from '../../assets/Images-2026/CTU/Bhubaneshwar Odisha4.jpg';
// import ctu2026Jaipur from '../../assets/Images-2026/CTU/Jaipur Rajasthan.jpg';
// import ctu2026Jalandhar from '../../assets/Images-2026/CTU/Jalandhar Punjab.jpg';
// import ctu2026Kanpur from '../../assets/Images-2026/CTU/Kanpur UP.jpg';
// Clean Public Spaces -> clean_public_places tab
// import cps2026Chandigarh from '../../assets/Images-2026/Clean Public Spaces/Chandigarh Junction.jpg';
// import cps2026Patna from '../../assets/Images-2026/Clean Public Spaces/JPNI Airport Patna, Bihar.jpg';
// import cps2026Patiala from '../../assets/Images-2026/Clean Public Spaces/Patiala Punjab.jpg';
// import cps2026Vijaywada from '../../assets/Images-2026/Clean Public Spaces/Vijaywada Andhra Pradesh.jpg';
// SafaiMitra Suraksha Shivir -> shivirs tab
// import shivir2026Thiruvananthapuram from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/DRM Thiruvananthapuram kerala.jpg';
// import shivir2026Kanpur from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/Kanpur UP.jpg';
// import shivir2026Kolkata from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/Kolkata West Bengal.jpg';
// import shivir2026Surat from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/Surat Gujrat.jpg';
// Clean Green Festivities -> clean_green_festives tab
// import festive2026Ahilyanagar from '../../assets/Images-2026/Clean Green Festivities/Ahilyanagar Maharashtra.jpg';
// import festive2026Brahmaputra from '../../assets/Images-2026/Clean Green Festivities/Brahmputra River Tinsukia Assam3.jpg';
// import festive2026Mandarmoni from '../../assets/Images-2026/Clean Green Festivities/Mandarmoni Sea Beach, West Bengal.jpg';
// import festive2026Rajgir from '../../assets/Images-2026/Clean Green Festivities/RTC CRPF Rajgir Bihar.jpg';
// Advocacy -> advocacy tab
// import advocacy2026Indirapuram from '../../assets/Images-2026/Advocacy/Indirapuram Ghaziabad UP.jpg';
// import advocacy2026Punjab from '../../assets/Images-2026/Advocacy/Punjab.jpg';
// import advocacy2026Ranchi from '../../assets/Images-2026/Advocacy/Ranchi Jharkhand.jpg';
// import advocacy2026Vijaywada from '../../assets/Images-2026/Advocacy/Vijaywada Andhra Pradesh.jpg';

// --- SHS-2026 gallery, second batch (added 2026-09-23) --------------------
// Rotated out 2026-10-05 when the fourth batch below went in; each tab keeps
// the newest eight. Files remain in src/assets/Images-2026/.
// CTU -> ctu tab
// import ctu2026Aska from '../../assets/Images-2026/CTU/Aska Odisha.jpg';
// import ctu2026Dhanbad from '../../assets/Images-2026/CTU/Dhanbad Jharkhand.jpg';
// import ctu2026Husnabad from '../../assets/Images-2026/CTU/Husnabad Telangana.jpg';
// import ctu2026IITDelhi from '../../assets/Images-2026/CTU/IIT Delhi.png';
// Clean Public Spaces -> clean_public_places tab
// import cps2026Jabalpur from '../../assets/Images-2026/Clean Public Spaces/Jabalpur CB.jpg';
// import cps2026Jalandhar from '../../assets/Images-2026/Clean Public Spaces/Jalandhar Punjab.jpg';
// import cps2026Jamtara from '../../assets/Images-2026/Clean Public Spaces/Jamtara Jharkhand.jpg';
// import cps2026Kargil from '../../assets/Images-2026/Clean Public Spaces/Kargil Laddakh.jpg';
// SafaiMitra Suraksha Shivir -> shivirs tab
// import shivir2026Liberia from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/India in Liberia.jpg';
// import shivir2026Kataka from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/Kataka Odisha.jpg';
// import shivir2026Dibrugarh from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/Northeast Frontier Railway Dibrugarh Assam.jpg';
// import shivir2026Kit from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/SafaiMitra Kit Thiruvananthapuram, Kerala.jpg';
// Clean Green Festivities -> clean_green_festives tab
// import festive2026AmritsarKatra from '../../assets/Images-2026/Clean Green Festivities/Amritsar-Katra Expressway.jpg';
// import festive2026Srinagar from '../../assets/Images-2026/Clean Green Festivities/CRPF Srinagar.jpg';
// import festive2026DwssPunjab from '../../assets/Images-2026/Clean Green Festivities/DWSS Punjab.jpg';
// import festive2026Mangaluru from '../../assets/Images-2026/Clean Green Festivities/Mangaluru Karnataka.png';
// Advocacy -> advocacy tab
// import advocacy2026Ghaziabad from '../../assets/Images-2026/Advocacy/Ghaziabad Awairness Jute Bags.png';
// import advocacy2026Jodhpur from '../../assets/Images-2026/Advocacy/Jodhpur Rajasthan.png';
// import advocacy2026Meerut from '../../assets/Images-2026/Advocacy/Meerut Awairness.png';
// import advocacy2026Chhattisgarh from '../../assets/Images-2026/Advocacy/Swachh Pathshala at Chhattisgarh.jpg';

// --- SHS-2026 gallery, third batch (added 2026-09-30) ---------------------
// Rotated out 2026-10-12 when the fifth batch below went in; each tab keeps
// the newest eight. Files remain in src/assets/Images-2026/.
// CTU -> ctu tab
// import ctu2026Pinjore from '../../assets/Images-2026/CTU/CTU GC CRPF _ Pinjore Haryana.jpg';
// import ctu2026OrgiKolkata from '../../assets/Images-2026/CTU/Language Division@ORGI, Kolkata @Language_ORGI.jpg';
// import ctu2026Sagar from '../../assets/Images-2026/CTU/Sagar Cantt Board.jpg';
// import ctu2026BbjKolkata from '../../assets/Images-2026/CTU/THE BBJ CONSTRUCTION CO LTD @BbjLtd Kolkata.jpg';
// Clean Public Spaces -> clean_public_places tab
// import cps2026Badgam from '../../assets/Images-2026/Clean Public Spaces/Badgam Railway Station_.jpg';
// import cps2026Khadki from '../../assets/Images-2026/Clean Public Spaces/CEO-Khadki Pune School.jpg';
// import cps2026InsShivaji from '../../assets/Images-2026/Clean Public Spaces/INS Shivaji.jpg';
// import cps2026Manuu from '../../assets/Images-2026/Clean Public Spaces/Maulana Azad National Urdu University @officialmanuu.jpg';
// SafaiMitra Suraksha Shivir -> shivirs tab
// import shivir2026Jabalpur from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/CB JABALPUR.jpg';
// import shivir2026KulluManali from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/Kullu-Manali Airport, Bhuntar.jpg';
// import shivir2026Siddipet from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/SafaiMitra Suraksha SBM Gramin_Siddipet.jpg';
// import shivir2026Sagar from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/Sagar Cantt Board.jpg';
// Clean Green Festivities -> clean_green_festives tab
// import festive2026AhilyanagarCantt from '../../assets/Images-2026/Clean Green Festivities/Ahilyanagar Cantonment Board.jpg';
// import festive2026IariPusa from '../../assets/Images-2026/Clean Green Festivities/ICAR-IARI Pusa New Delhi.jpg';
// import festive2026IiwmBhubaneswar from '../../assets/Images-2026/Clean Green Festivities/ICAR-IIWM Bhuvaneshwar Odisha.jpg';
// import festive2026MnitJaipur from '../../assets/Images-2026/Clean Green Festivities/Malaviya National Institute of Technology, Jaipur @NIT_Jaipur.jpg';
// Advocacy -> advocacy tab
// import advocacy2026Dindigul from '../../assets/Images-2026/Advocacy/Dindigul Tamilnadu.jpg';
// import advocacy2026Nirm from '../../assets/Images-2026/Advocacy/National Institute of Rock Mechanics Bengaluru.jpg';
// import advocacy2026Ratlam from '../../assets/Images-2026/Advocacy/Ratlam SHS Activity.jpg';
// import advocacy2026Sagar from '../../assets/Images-2026/Advocacy/SAGAR CANTT BOARD.jpg';

// --- SHS-2026 gallery, fourth batch (added 2026-10-05) --------------------
// Ordered ahead of the third batch in imagesByCategory below, so these show
// first in every tab.
// CTU -> ctu tab
import ctu2026AhilyaNagar from '../../assets/Images-2026/CTU/Ahilya Nagar Maharashtra.jpg';
import ctu2026Fatehgarh from '../../assets/Images-2026/CTU/CB Fatehgarh UP.png';
import ctu2026MysuruMangaluru from '../../assets/Images-2026/CTU/DRM Mysuru Mangaluru Karnataka.jpg';
import ctu2026Kishanganj from '../../assets/Images-2026/CTU/Kishanganj Bihar.jpg';
// Clean Public Spaces -> clean_public_places tab
import cps2026FciBhopal from '../../assets/Images-2026/Clean Public Spaces/FCI DO BHOPAL MP.jpg';
import cps2026IimcDhenkanal from '../../assets/Images-2026/Clean Public Spaces/IIMC Dhenkanal Odisha.jpg';
import cps2026Jodhpur from '../../assets/Images-2026/Clean Public Spaces/Jodhpur Rajasthan.jpg';
import cps2026Pipli from '../../assets/Images-2026/Clean Public Spaces/Pipli Odisha.jpg';
// SafaiMitra Suraksha Shivir -> shivirs tab
import shivir2026AphoNagpur from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/APHO NAGPUR Maharashtra.jpg';
import shivir2026Paramakudi from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/DRM MADURAI Parmakudi TN.jpg';
import shivir2026Manthani from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/Manthani Telangana.jpg';
import shivir2026SaiRohtak from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/SAI_Rohtak Haryana.jpg';
// Clean Green Festivities -> clean_green_festives tab
import festive2026Wellington from '../../assets/Images-2026/Clean Green Festivities/CB Wellington Tamilnadu.jpg';
import festive2026Sambalpur from '../../assets/Images-2026/Clean Green Festivities/DRMSambalpur Odisha.jpg';
import festive2026IariPusa2 from '../../assets/Images-2026/Clean Green Festivities/ICAR-IARI Pusa New Delhi @iaripusa1.jpg';
import festive2026Shillong from '../../assets/Images-2026/Clean Green Festivities/Shillong Meghalaya.jpg';
// Advocacy -> advocacy tab
import advocacy2026AhmedabadCB from '../../assets/Images-2026/Advocacy/Ahmedabad CB Gujarat.jpg';
import advocacy2026Chatrapur from '../../assets/Images-2026/Advocacy/Chatrapur Odisha.jpg';
import advocacy2026PressCouncil from '../../assets/Images-2026/Advocacy/Press Council of India @PressCouncil_IN.jpg';
import advocacy2026SouthernCommand from '../../assets/Images-2026/Advocacy/Southern Command Chennai.jpg';

// --- SHS-2026 gallery, fifth batch (added 2026-10-12) ---------------------
// Ordered ahead of the fourth batch in imagesByCategory below, so these show
// first in every tab.
// CTU -> ctu tab
import ctu2026Chakrata from '../../assets/Images-2026/CTU/CB Chakrata.jpg';
import ctu2026ClementTown from '../../assets/Images-2026/CTU/ClementTownCB DD Uttarakhand.png';
import ctu2026KillaPardi from '../../assets/Images-2026/CTU/Killa pardi Gujarat.jpg';
import ctu2026Chhattarpur from '../../assets/Images-2026/CTU/NPP Chhattarpur MP.jpg';
// Clean Public Spaces -> clean_public_places tab
import cps2026Ambala from '../../assets/Images-2026/Clean Public Spaces/CB Ambala.jpg';
import cps2026Stm from '../../assets/Images-2026/Clean Public Spaces/CB STM.jpg';
import cps2026HandiqueCollege from '../../assets/Images-2026/Clean Public Spaces/Handique Girls_ College.png';
import cps2026SouthernRailway from '../../assets/Images-2026/Clean Public Spaces/Southern Railway Chennai.jpg';
// SafaiMitra Suraksha Shivir -> shivirs tab
import shivir2026JalandharCB from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/CB Jalandhar.jpg';
import shivir2026Roorkee from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/cb roorkee.jpg';
import shivir2026Nagaland from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/Nagaland, UP.jpg';
import shivir2026SouthTripura from '../../assets/Images-2026/SafaiMitra Suraksha Shivir/South Tripura_.jpg';
// Clean Green Festivities -> clean_green_festives tab
import festive2026Almora from '../../assets/Images-2026/Clean Green Festivities/CB ALMORA.jpg';
import festive2026Fatehgarh from '../../assets/Images-2026/Clean Green Festivities/CB Fatehgarh.jpg';
import festive2026Fatehgarh2 from '../../assets/Images-2026/Clean Green Festivities/CB Fatehgarh(1).jpg';
import festive2026Jabalpur from '../../assets/Images-2026/Clean Green Festivities/CB JABALPUR.jpg';
// Advocacy -> advocacy tab
import advocacy2026Chakrata from '../../assets/Images-2026/Advocacy/CB Chakrata.jpg';
import advocacy2026Dehradun from '../../assets/Images-2026/Advocacy/CB Dehradun.jpg';
import advocacy2026JalandharCB from '../../assets/Images-2026/Advocacy/CB Jalandhar.jpg';
import advocacy2026Jalapahar from '../../assets/Images-2026/Advocacy/JALAPAHAR CB.jpg';

const MediaGallery = ({ images }) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [activeTab, setActiveTab] = useState(0);

  // Define the 5 tabs
  const tabs = [
    { label: 'CTU', key: 'ctu' },
    { label: 'Clean Public Spaces', key: 'clean_public_places' },
    { label: 'SafaiMitra Suraksha Shivirs', key: 'shivirs' },
    { label: 'Clean Green Festivities', key: 'clean_green_festives' },
    { label: 'Advocacy', key: 'advocacy' },
  ];

  // Organize images by category
  const imagesByCategory = {
    ctu: [
      // fifth batch (2026-10-12) -- shown first
      ctu2026Chakrata,
      ctu2026ClementTown,
      ctu2026KillaPardi,
      ctu2026Chhattarpur,
      // fourth batch (2026-10-05)
      ctu2026AhilyaNagar,
      ctu2026Fatehgarh,
      ctu2026MysuruMangaluru,
      ctu2026Kishanganj,
      // third batch (2026-09-30), rotated out 2026-10-12
      // ctu2026Pinjore,
      // ctu2026OrgiKolkata,
      // ctu2026Sagar,
      // ctu2026BbjKolkata,
      // second batch (2026-09-23), rotated out 2026-10-05
      // ctu2026Aska,
      // ctu2026Dhanbad,
      // ctu2026Husnabad,
      // ctu2026IITDelhi,
      // first batch (2026-09-21), rotated out 2026-09-30
      // ctu2026Bhubaneshwar,
      // ctu2026Jaipur,
      // ctu2026Jalandhar,
      // ctu2026Kanpur,
      // --- previous images, replaced 2026-09-21; uncomment to restore ---
      // ctuImg67,
      // ctuImg68,
      // ctuImg69,
      // ctuImg62,
      // ctuImg63,
      // ctuImg64,
      // ctuImg65,
      // ctuImg66,
      // ctuImg57,
      // ctuImg58,
      // ctuImg59,
      // ctuImg60,
      // ctuImg61,
      // ctuImg51,
      // ctuImg52,
      // ctuImg53,
      // ctuImg54,
      // ctuImg55,
      // ctuImg56,
      // ctuImg47,
      // ctuImg48,
      // ctuImg49,
      // ctuImg50,
      // ctuImg45,
      // ctuImg35,
      // ctuImg36,
      // ctuImg37,
      // ctuImg38,
      // ctuImg39,
      // ctuImg40,
      // ctuImg41,
      // ctuImg42,
      // ctuImg43,
      // ctuImg33,
      // ctuImg34,
      // ctuImg28,
      // ctuImg24,
      // ctuImg25,
      // ctuImg26,
      // ctuImg27,
      // ctuImg29,
      // ctuImg30,
      // ctuImg31,
      // ctuImg32,
      // ctuImg13,
      // ctuImg14,
      // ctuImg15,
      // ctuImg16,
      // ctuImg17,
      // ctuImg18,
      // ctuImg19,
      // ctuImg20,
      // ctuImg21,
      // ctuImg22,
      // ctuImg23,
      // ctuImg8,
      // ctuImg10,
      // ctuImg11,
    ],
    advocacy: [
      // fifth batch (2026-10-12) -- shown first
      advocacy2026Chakrata,
      advocacy2026Dehradun,
      advocacy2026JalandharCB,
      advocacy2026Jalapahar,
      // fourth batch (2026-10-05)
      advocacy2026AhmedabadCB,
      advocacy2026Chatrapur,
      advocacy2026PressCouncil,
      advocacy2026SouthernCommand,
      // third batch (2026-09-30), rotated out 2026-10-12
      // advocacy2026Dindigul,
      // advocacy2026Nirm,
      // advocacy2026Ratlam,
      // advocacy2026Sagar,
      // second batch (2026-09-23), rotated out 2026-10-05
      // advocacy2026Ghaziabad,
      // advocacy2026Jodhpur,
      // advocacy2026Meerut,
      // advocacy2026Chhattisgarh,
      // first batch (2026-09-21), rotated out 2026-09-30
      // advocacy2026Indirapuram,
      // advocacy2026Punjab,
      // advocacy2026Ranchi,
      // advocacy2026Vijaywada,
      // --- previous images, replaced 2026-09-21; uncomment to restore ---
      // advocacyImg53,
      // advocacyImg54,
      // advocacyImg48,
      // advocacyImg49,
      // advocacyImg50,
      // advocacyImg51,
      // advocacyImg52,
      // advocacyImg43,
      // advocacyImg44,
      // advocacyImg45,
      // advocacyImg46,
      // advocacyImg47,
      // advocacyImg37,
      // advocacyImg38,
      // advocacyImg39,
      // advocacyImg40,
      // advocacyImg41,
      // advocacyImg42,
      // advocacyImg32,
      // advocacyImg33,
      // advocacyImg34,
      // advocacyImg35,
      // advocacyImg36,
      // advocacyImg26,
      // advocacyImg27,
      // advocacyImg28,
      // advocacyImg29,
      // advocacyImg30,
      // advocacyImg31,
      // advocacyImg20,
      // advocacyImg21,
      // advocacyImg22,
      // advocacyImg23,
      // advocacyImg24,
      // advocacyImg25,
      // advocacyImg17,
      // advocacyImg18,
      // advocacyImg19,
      // advocacyImg4,
      // advocacyImg7,
      // advocacyImg8,
      // advocacyImg9,
      // advocacyImg10,
      // advocacyImg1,
      // advocacyImg2,
      // advocacyImg3,
      // advocacyImg5,
      // advocacyImg6,
      // advocacyImg11,
      // advocacyImg12,
      // advocacyImg13,
      // advocacyImg14,
      // advocacyImg15,
      // advocacyImg16,
    ],
    clean_green_festives: [
      // fifth batch (2026-10-12) -- shown first
      festive2026Almora,
      festive2026Fatehgarh,
      festive2026Fatehgarh2,
      festive2026Jabalpur,
      // fourth batch (2026-10-05)
      festive2026Wellington,
      festive2026Sambalpur,
      festive2026IariPusa2,
      festive2026Shillong,
      // third batch (2026-09-30), rotated out 2026-10-12
      // festive2026AhilyanagarCantt,
      // festive2026IariPusa,
      // festive2026IiwmBhubaneswar,
      // festive2026MnitJaipur,
      // second batch (2026-09-23), rotated out 2026-10-05
      // festive2026AmritsarKatra,
      // festive2026Srinagar,
      // festive2026DwssPunjab,
      // festive2026Mangaluru,
      // first batch (2026-09-21), rotated out 2026-09-30
      // festive2026Ahilyanagar,
      // festive2026Brahmaputra,
      // festive2026Mandarmoni,
      // festive2026Rajgir,
      // --- previous images, replaced 2026-09-21; uncomment to restore ---
      // festiveImg16,
      // festiveImg17,
      // festiveImg18,
      // festiveImg14,
      // festiveImg15,
      // festiveImg13,
      // festiveImg12,
      // festiveImg9,
      // festiveImg10,
      // festiveImg11,
      // festiveImg8,
      // festiveImg1,
      // festiveImg2,
      // festiveImg3,
      // festiveImg4,
      // festiveImg5,
      // festiveImg6,
      // festiveImg7,
    ],
    clean_public_places: [
      // fifth batch (2026-10-12) -- shown first
      cps2026Ambala,
      cps2026Stm,
      cps2026HandiqueCollege,
      cps2026SouthernRailway,
      // fourth batch (2026-10-05)
      cps2026FciBhopal,
      cps2026IimcDhenkanal,
      cps2026Jodhpur,
      cps2026Pipli,
      // third batch (2026-09-30), rotated out 2026-10-12
      // cps2026Badgam,
      // cps2026Khadki,
      // cps2026InsShivaji,
      // cps2026Manuu,
      // second batch (2026-09-23), rotated out 2026-10-05
      // cps2026Jabalpur,
      // cps2026Jalandhar,
      // cps2026Jamtara,
      // cps2026Kargil,
      // first batch (2026-09-21), rotated out 2026-09-30
      // cps2026Chandigarh,
      // cps2026Patna,
      // cps2026Patiala,
      // cps2026Vijaywada,
      // --- previous images, replaced 2026-09-21; uncomment to restore ---
      // publicImg51,
      // publicImg52,
      // publicImg53,
      // publicImg47,
      // publicImg48,
      // publicImg49,
      // publicImg50,
      // publicImg40,
      // publicImg41,
      // publicImg42,
      // publicImg43,
      // publicImg44,
      // publicImg45,
      // publicImg46,
      // publicImg35,
      // publicImg36,
      // publicImg37,
      // publicImg38,
      // publicImg39,
      // publicImg31,
      // publicImg32,
      // publicImg33,
      // publicImg34,
      // publicImg26,
      // publicImg27,
      // publicImg28,
      // publicImg29,
      // publicImg30,
      // publicImg20,
      // publicImg21,
      // publicImg22,
      // publicImg23,
      // publicImg24,
      // publicImg25,
      // publicImg17,
      // publicImg18,
      // publicImg19,
      // publicImg1,
      // publicImg2,
      // publicImg6,
      // publicImg7,
      // publicImg16,
      // publicImg10,
      // publicImg11,
      // publicImg12,
      // publicImg13,
      // publicImg14,
      // publicImg15,
      // publicImg3,
      // publicImg4,
      // publicImg5,
      // publicImg8,
      // publicImg9,
      // ctuImg1,
      // ctuImg2,
    ],
    shivirs: [
      // fifth batch (2026-10-12) -- shown first
      shivir2026JalandharCB,
      shivir2026Roorkee,
      shivir2026Nagaland,
      shivir2026SouthTripura,
      // fourth batch (2026-10-05)
      shivir2026AphoNagpur,
      shivir2026Paramakudi,
      shivir2026Manthani,
      shivir2026SaiRohtak,
      // third batch (2026-09-30), rotated out 2026-10-12
      // shivir2026Jabalpur,
      // shivir2026KulluManali,
      // shivir2026Siddipet,
      // shivir2026Sagar,
      // second batch (2026-09-23), rotated out 2026-10-05
      // shivir2026Liberia,
      // shivir2026Kataka,
      // shivir2026Dibrugarh,
      // shivir2026Kit,
      // first batch (2026-09-21), rotated out 2026-09-30
      // shivir2026Thiruvananthapuram,
      // shivir2026Kanpur,
      // shivir2026Kolkata,
      // shivir2026Surat,
      // --- previous images, replaced 2026-09-21; uncomment to restore ---
      // shivirImg26,
      // shivirImg27,
      // shivirImg23,
      // shivirImg24,
      // shivirImg25,
      // shivirImg22,
      // shivirImg21,
      // shivirImg20,
      // shivirImg17,
      // shivirImg18,
      // shivirImg19,
      // shivirImg13,
      // shivirImg14,
      // shivirImg15,
      // shivirImg16,
      // shivirImg9,
      // shivirImg10,
      // shivirImg11,
      // shivirImg12,
      // shivirImg1,
      // shivirImg2,
      // shivirImg3,
      // shivirImg4,
      // shivirImg5,
      // shivirImg6,
      // shivirImg7,
      // shivirImg8,
    ],
  };

  // Filter images based on active tab
  const getFilteredImages = () => {
    const currentTab = tabs[activeTab];
    return imagesByCategory[currentTab.key] || [];
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const openLightbox = (index) => {
    setPhotoIndex(index);
    setIsOpen(true);
  };

  const filteredImages = getFilteredImages();

  // console.log('images', images);
  return (
    <Box
      sx={{
        paddingTop: '5%',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <Typography
        variant="h1"
        className="main-heading my-2"
        style={{
          whiteSpace: 'nowrap',
          fontWeight: '700',
          fontFamily: 'Roboto',
          textAlign: 'center',
          color: '#3939A0',
        }}
      >
        {t('media_gallery')}
      </Typography>

      {/* Tabs for different categories */}
      <Box sx={{ display: 'flex', justifyContent: 'center', mb: 3 }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{
            '& .MuiTab-root': {
              fontWeight: 600,
              fontSize: { xs: '1.1rem', md: '1.25rem' },
              color: '#3939A0',
              minHeight: { xs: '56px', md: '64px' },
              paddingX: { xs: 2, md: 3 },
              marginX: { xs: 0.5, md: 1 },
            },
            '& .MuiTab-root.Mui-selected': {
              color: '#3939A0',
            },
            '& .MuiTabs-indicator': {
              backgroundColor: '#3939A0',
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab key={tab.key} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      <Grid
        container
        sx={{
          padding: '5%',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        {filteredImages?.map((data, index) => (
          <Col
            xs={6}
            lg={3}
            className="hashtagImg_sm"
            style={{ display: 'inline-block' }}
            key={Math.random()}
          >
            <div
              style={{
                borderRadius: '15px',
                position: 'relative',
                overflow: 'hidden',
                margin: '10px',
              }}
              onClick={() => {
                openLightbox(index);
              }}
            >
              <VillageImageDiv
                style={{
                  backgroundColor: '#fff',
                  borderRadius: '15px',
                  backgroundSize: 'cover',
                  filter: 'blur(40px)',
                  height: '15vh',
                  // border: '1px solid black',
                  overflow: 'hidden',
                  // Quoted: the 2026 filenames contain spaces and commas, which are
                  // invalid in an unquoted CSS url() -- the browser drops the
                  // whole declaration and the card renders blank.
                  backgroundImage: `url("${data}")`,
                  cursor: 'pointer',
                }}
              />
              <VillageImageDiv
                className="th-border-top th-border-bottom"
                style={{
                  borderRadius: '15px',
                  position: 'absolute',
                  top: '0%',
                  right: '0%',
                  // border: '2px solid transparent',
                  bottom: '0%',
                  backgroundSize: 'contain',
                  // Quoted: the 2026 filenames contain spaces and commas, which are
                  // invalid in an unquoted CSS url() -- the browser drops the
                  // whole declaration and the card renders blank.
                  backgroundImage: `url("${data}")`,
                  cursor: 'pointer',
                }}
              />
            </div>
          </Col>
        ))}
      </Grid>
    </Box>
  );
};

export default MediaGallery;

export const VillageImageDiv = styled.div`
  background: url(image.png);
  width: 100%;
  padding-bottom: 50%;
  background-size: contain;
  background-repeat: no-repeat !important;
  background-color: '#555';
  background-position: center;
  border-radius: 20px;
`;
